import {useUser} from '@/public/contexts/UserContext';
import HeaderView from './HeaderView';

function Header() {
  const user = useUser();
  return <HeaderView publicUser={user} />;
}

export default Header;
